import { getReq, putReq, postReq, deleteReq } from '../api/restHelper'

function getWs(dispatch){
    getReq('workspace?page=1&per_page=-1', (response)=>{
        dispatch({ type: "SET_WORKSPACE_LIST", payload: response.data.list })
    });
}

export function getWorkspaceList() {
    return (dispatch)=> {
        getWs(dispatch)
    }
}

export function deleteWorkspace(id){
    return (dispatch) => {
        deleteReq('workspace/' + id, (response)=>{
            getWs(dispatch)
        })
    }
}

export function openModal(index) {
    return {
        type: "OPEN_WS_MODAL",
        payload: index
    }
}

export function closeModal() {
    return {
        type: "CLOSE_WS_MODAL",
    }
}

export function updateData(data, values, closeModal){
    return (dispatch, getState)=>{

        let obj = {
            'name': values.name,
            'users': []
        };

        for(let user of data.users){
            if(user.phone_number !== data.owner.phone_number){
                obj.users.push(user.phone_number)
            }
        }

        if(data.id && data.id !== -1){
            putReq(obj, 'workspace/'+ data.id, (response)=>{
                getWs(dispatch)
                closeModal();
            })
        }else{
            postReq(obj,'workspace',(response)=>{
                getWs(dispatch)
                closeModal();
            })
        }
    }
}
